import { createContext, useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../WebSocket/WebSocketContext"
import { CondominiosContext } from "../CondominiosContext/CondominiosContext"
import { formatDate, showNotify } from "../../Utils/Utils"
import { UserContext } from "../UserContext/UserContex"
import getToken from "../../Utils/One_Auth"
import OneModal from "../../Components/OneModal/OneModal"
import { Box, Button } from "@mui/material"
import { EventosContext } from "../EventosContext/EventosContext"
import TratarEventoBl from "../../Pages/MonitoramentoPage/TratarEvento/TratarEventoBl"
import { validarCPF } from "../../Utils/tratarCpf"

let capturarFoto = false
let salvarParaAutorizacao = false

export const VisitantesContext = createContext()

export const VisitantesProvider = ({ children }) => {
    const { activeCond } = useContext(CondominiosContext)
    const { user } = useContext(UserContext)
    const { updateObsIframe, eventoSelecionado } = useContext(EventosContext)
    const { finalizarEvento } = TratarEventoBl()

    const { addRoute, sendWs, sendWsCortex } = useContext(WebSocketContext)

    const [visitanteInfo, setVisitanteInfo] = useState(null)
    const [visitantes, setVisitantes] = useState([])
    const [moradores, setMoradores] = useState(null)

    const [moradoresSelecionados, setMoradoresSelecionados] = useState([])
    const [visitantesSelecionados, setVisitantesSelecionados] = useState([])

    const [imoveis, setImoveis] = useState(null)

    const [imovelSelecionado, setImovelSelecionado] = useState(null)

    const [novoVisitante, setNovoVisitante] = useState(false)

    const [listaSaida, setListaSaida] = useState([])

    const [openModalCapFoto, setOpenModalCapFoto] = useState(false)

    const [aguardandoCapFoto, setAguardandoCapFoto] = useState(false)

    const [tabIndex, setTabIndex] = useState(0)

    const [eventoVisitante, setEventoVisitante] = useState(null)

    const [nomeMoradorBusca, setNomeMoradorBusca] = useState('')

    const [metricas, setMetricas] = useState({ visitantes: 0, prest: 0, hospede: 0 })

    const [modoExibicao, setModoExibicao] = useState(localStorage.getItem('modoExibicao') || 'card')

    const [liberarMorador, setLiberarMorador] = useState(false)

    const [jaLiberouAcesso, setJaLiberouAcesso] = useState(false)

    const [autorizarVisitante, setAutorizarVisitante] = useState(false)

    const [autorizarVisitanteNotificarMorador, setAutorizarVisitanteNotificarMorador] = useState(null)

    const [localizacaoImoveis, setLocalizacaoImoveis] = useState([])

    const [autorizados, setAutorizados] = useState(null)
    const [convites, setConvites] = useState(null)

    const [abrirModalAutorizacao, setAbrirModalAutorizacao] = useState(false)
    const [solicitarSalvarVisitante, setSolicitarSalvarVisitante] = useState(false)

    addRoute('buscarAutorizadosPorVisitante', (msg) => {
        setAutorizados(msg.data.autorizados)
    })

    addRoute('buscarTodosConvitesPorConvidados', (msg) => {
        setConvites(msg.data.convites)
    })

    const finalizarECriarEventoVisitante = () => {
        finalizarEvento()
        sendWs("gerarEventoVisitante", {
            id_central: activeCond.id_central,
            evento: 'OVIS',
            auxiliar: '',
            nomeUsuario: user.nome,
            idUsuario: user.id,
            ramal: ''
        })
    }

    const mudarExibicao = () => {
        modoExibicao == 'card' ? setModoExibicao('list') : setModoExibicao('card')
        localStorage.setItem('modoExibicao', modoExibicao == 'card' ? 'list' : 'card')
    }

    const limparContext = () => {
        setVisitanteInfo(null)
        setAutorizarVisitante(false)
        setAutorizarVisitanteNotificarMorador(false)
        setVisitantes([])
        setMoradoresSelecionados([])
        setImoveis(null)
        setImovelSelecionado(null)
        setNovoVisitante(false)
        setMoradores(null)
        setVisitantesSelecionados([])
        setLocalizacaoImoveis([])
        setAutorizados(null)
        setConvites(null)
    }

    useEffect(() => {
        if (eventoVisitante == null) {
            setEventoVisitante(eventoSelecionado)
        } else {
            if ((eventoSelecionado.evento == 'OVIS' || eventoSelecionado.evento == 'OINI') && eventoSelecionado.id != eventoVisitante.id) {
                setTabIndex(0)
                limparContext()
                setTimeout(() => {
                    setEventoVisitante(eventoSelecionado)
                }, 500)
            }
        }
    }, [eventoSelecionado])

    const addMoradorSelecionado = (morador) => {
        if (moradoresSelecionados.find(m => m.CD_ACESSO == morador.CD_ACESSO)) {
            showNotify('warning', 'Morador já adicionado!')
        } else if (morador.bloqueado) {
            showNotify('warning', 'Morador bloqueado! Não é possível adicionar um morador bloqueado!')
        } else {
            if (morador.lat != null && morador.lng != null) {
                if (localizacaoImoveis.find(l => l.idImovel == imovelSelecionado.id)) {
                    console.log('Localização já adicionada para este imóvel! Por isso não será adicionada novamente!')
                } else {
                    const objLocalizacao = {
                        lat: morador.lat,
                        lng: morador.lng,
                        nomeMorador: morador.nome,
                        telefoneMorador: morador.telefone,
                        nomeImovel: `${activeCond.tipo_imovel} ${imovelSelecionado.unidade1} - ${activeCond.desc_tipo_imovel} ${imovelSelecionado.unidade2}`,
                        idImovel: imovelSelecionado.id,
                        CD_ACESSO: morador.CD_ACESSO
                    }
                    setLocalizacaoImoveis([...localizacaoImoveis, objLocalizacao])
                }
            }
            setMoradoresSelecionados([...moradoresSelecionados, morador])
        }
    }

    const setLiberarMoradorButton = (params) => {
        setLiberarMorador(params)
    }

    const removeMoradorSelecionado = (CD_ACESSO) => {
        const moradores = moradoresSelecionados.filter(m => m.CD_ACESSO != CD_ACESSO)
        setMoradoresSelecionados(moradores)
        setLocalizacaoImoveis(localizacaoImoveis.filter(l => l.CD_ACESSO != CD_ACESSO))
    }

    const addVisitanteSelecionado = (visitante) => {
        if (visitante.bloqueado) {
            showNotify('warning', 'Visitante bloqueado! Não é possível adicionar um visitante bloqueado!')
            return
        }

        if (visitantesSelecionados.find(v => v.CD_ACESSO == visitante.CD_ACESSO)) {
            visitantesSelecionados[visitantesSelecionados.findIndex(v => v.CD_ACESSO == visitante.CD_ACESSO)] = visitante
        } else {
            setVisitantesSelecionados([...visitantesSelecionados, visitante])
        }
        setVisitanteInfo(null)
        setAutorizarVisitante(false)
    }

    const removeVisitanteSelecionado = (CD_ACESSO) => {
        const visitantes = visitantesSelecionados.filter(v => v.CD_ACESSO != CD_ACESSO)
        setVisitantesSelecionados(visitantes)
    }

    const selecionarAutorizacao = (autorizado) => {
        if (autorizado.bloqueado) {
            showNotify('warning', 'Visitante bloqueado! Não é possível autorizar um visitante bloqueado!')
            return
        }

        setAutorizarVisitanteNotificarMorador(autorizado.notificar_morador)

        if (autorizado.lat && autorizado.lon) {
            const objLocalizacao = {
                lat: autorizado.lat,
                lng: autorizado.lon,
                nomeMorador: autorizado.nome,
                telefoneMorador: autorizado.telefone,
                nomeImovel: `${activeCond.tipo_imovel} ${imovelSelecionado.unidade1} - ${activeCond.desc_tipo_imovel} ${imovelSelecionado.unidade2}`,
                idImovel: imovelSelecionado.id,
                CD_ACESSO: autorizado.cd_acesso
            }
            setLocalizacaoImoveis([objLocalizacao])
        }
        setMoradoresSelecionados([autorizado])
        setAutorizarVisitante(true)
    }

    const mudarImovelSelecionado = (imovel) => {
        setImovelSelecionado(imovel)
    }

    const buscaVisitantes = (msg) => {
        setImoveis(msg.data.imoveis)
    }
    addRoute('buscarImoveisPorTexto', buscaVisitantes)

    const buscarPorTexto = (texto, tipo) => {
        setMoradores(null)
        if (tipo == 'nome') {
            setNomeMoradorBusca(texto)
            sendWs('buscarImoveisPorTexto', { id_central: activeCond.id_central, nome: texto, tipoFiltro: 'morador' })
        } else if (tipo == 'imovel') {
            setNomeMoradorBusca('')
            sendWs('buscarImoveisPorTexto', { id_central: activeCond.id_central, nome: texto, tipoFiltro: 'imovel' })
        } else {
            setNomeMoradorBusca(texto)
            sendWs('buscarImoveisPorTexto', { id_central: activeCond.id_central, nome: texto, tipoFiltro: 'todos' })
        }
    }

    const buscarMoradores = (msg) => {
        let moradoresBuscados = msg.data.moradores
        if (moradoresBuscados.length > 0) {
            moradoresBuscados.forEach(m => {
                if (m.obs) {
                    let obs = m.obs.split('\n')
                    let telefones = []
                    obs.forEach(o => {
                        if (o != '' && o.length > 4) {
                            if (o.substr(0, 2).toUpperCase() == 'F:') {
                                telefones.push(o.substr(2).trim())
                            } else if (o.substr(0, 5).toUpperCase() == 'FONE:') {
                                telefones.push(o.substr(5).trim())
                            }
                        }
                    })
                    m.obsTelefones = telefones
                }
            })
        }
        if (nomeMoradorBusca != '') {
            const moradores = moradoresBuscados.filter(m => m.nome.toLowerCase().includes(nomeMoradorBusca.toLowerCase() || m.imovel.toLowerCase().includes(nomeMoradorBusca.toLowerCase())))
            if (moradores.length == 0) {
                setMoradores(moradoresBuscados)
            } else {
                setMoradores(moradores)
            }
        } else {
            setMoradores(moradoresBuscados)
        }
    }

    const buscarMoradorPorFiltro = (filtro) => {
        addRoute('buscarMoradorPorFiltro', buscarMoradores)
        if (filtro && filtro.idImovel) {
            let imovel = imoveis.find(i => i.id == filtro.idImovel)
            setImovelSelecionado(imovel)
        }
        sendWs('buscarMoradorPorFiltro', { id_central: activeCond.id_central, ...filtro })
    }

    const recebeVisitados = (msg) => {
        setImoveis(msg.data.visitados.imoveis)
    }

    const buscarVisitados = (texto, tipo) => {
        setMoradores(null)
        if (tipo == 'imovel') {
            setNomeMoradorBusca('')
        } else {
            setNomeMoradorBusca(texto)
        }
        addRoute('buscarTelaVisitados', recebeVisitados)
        sendWs('buscarTelaVisitados', { id_central: activeCond.id_central, nome: texto, tipoFiltro: tipo })
    }

    const mudaImovelSelecionado = (imovel) => {
        setImovelSelecionado(imovel)
        setMoradores(imovel.moradores)
    }

    const buscarVisitantesSaida = (msg) => {
        setListaSaida([...msg.data.listaSaida.visitantesAutorizados, ...msg.data.listaSaida.entrouDispositivo])

        setMetricas({
            visitantes: msg.data.listaSaida.totalMetricas['Visitantes (AppOne)'],
            prest: msg.data.listaSaida.totalMetricas['Prest. Serviço (AppOne)'],
            hospede: msg.data.listaSaida.totalMetricas['Hóspede (AppOne)']
        })
    }
    addRoute('listaVisitantesSaida', buscarVisitantesSaida)

    const pesquisaNomeCpfImovel = (texto) => {
        sendWs('listaVisitantesSaida', { filtros: { id_central: activeCond.id_central, filtro: texto } })
    }

    const buscarMsgApp = (cd_acesso) => {
        sendWs('listaMensagensApp', { id_central: activeCond.id_central, cd_acesso })
    }

    const enviarMsgApp = (cd_acesso, mensagem, autor, todos = 0, id_imovel = false) => {
        sendWs('enviaMensagemApp', { cd_acesso, id_central: activeCond.id_central, mensagem, autor, todos, id_imovel })
    }

    const receberInfoVisitante = (msg) => {
        let visitante = msg.data.moradores && msg.data.moradores[0]
        visitante.NASCIMENTO = formatDate(visitante.NASCIMENTO, 'yyyy-MM-DD')
        switch (visitante.ID_FUNCAO) {
            case 10013:
                visitante.ID_FUNCAO = 'Visitante'
                break
            case 10014:
                visitante.ID_FUNCAO = 'Prestador Serviço'
                break
            case 10010:
                visitante.ID_FUNCAO = 'Autorizado'
                break
            case 10015:
                visitante.ID_FUNCAO = 'Hóspede'
                break
            default:
                visitante.ID_FUNCAO = 'Visitante'
                break
        }
        setVisitanteInfo(visitante)
        setNovoVisitante(null)
    }

    const buscarInfoVisitante = (cd_acesso) => {
        setAutorizados(null)
        setConvites(null)
        addRoute('buscarMoradorPorFiltro', receberInfoVisitante)
        sendWs('buscarMoradorPorFiltro', { cd_acesso, id_central: activeCond.id_central, visitante: true, buscarTags: true })
    }

    const ativarNovoVisitante = (valueInput) => {
        setNovoVisitante(true)
        setAutorizados([])
        setConvites([])
        if (valueInput && IsFormatoCPF(valueInput)) {
            setVisitanteInfo({ cpf: valueInput })
        } else {
            setVisitanteInfo(null)
            setAutorizarVisitante(false)
        }
    }

    const IsFormatoCPF = (str) => {
        const regex = /^[0-9.-]+$/
        return regex.test(str)
    }

    const criarVisitante = async (visitante, ip_equip = false) => {
        setVisitanteInfo(visitante)

        let resultCpf = validarCPF(visitante.cpf, activeCond.pais)
        if ((activeCond.cpf_obrigatorio == 1 && (resultCpf !== 'ok')) || (activeCond.cpf_obrigatorio == 0 && !!visitante.cpf && resultCpf !== 'ok')) {
            showNotify('warning', resultCpf)
            return
        }
        if (!visitante.nome || visitante.nome == '') {
            showNotify('warning', 'Preencha o campo Nome!')
            return
        }
        if (visitante.capFoto) {
            capturarFoto = true
            delete visitante.capFoto
            visitante.gerarTag = true
            showNotify('info', 'Aguarde enquanto a foto é capturada!')
        }

        if (visitante.salvarParaAutorizacao) {
            salvarParaAutorizacao = true
            delete visitante.salvarParaAutorizacao
        }

        const visitanteObj = {
            acao: 'postPessoa',
            tipo_pessoa: visitante.ID_FUNCAO || 'Visitante',
            codigo_externo: visitante.codigo_externo,
            tipo_sistema: "PLUS",
            tipoSistema: "PLUS",
            cpf: visitante.cpf,
            nome: visitante.nome,
            nascimento: formatDate(visitante.NASCIMENTO),
            tel1: visitante.telefone,
            id_central: activeCond.id_central,
            placa_veiculo: visitante.placa,
            cep: visitante.CEP,
            endereco: visitante.ENDERECO,
            numero: visitante.NUMERO,
            obs: visitante.obs,
            responsavel_modificacao: user.nome,
            face: visitante.face,
            gerarTag: visitante.gerarTag ? 1 : 0,
            gerarTagFacial: visitante.gerarTag ? 'true' : 'false',
            validade_doc1: formatDate(visitante.validade_doc1),
            validade_doc2: formatDate(visitante.validade_doc2),
            validade_doc3: formatDate(visitante.validade_doc3),
            forcar_sinc_face: false // face só vai ser sincronizada para o cortex em um segundo momento, quando operadora clicar em 'liberar acesso'
        }

        if (visitante.imgDocumento) {
            visitanteObj.imagemdocumento = visitante.imgDocumento
        }
        if (visitante.imgDocumento2) {
            visitanteObj.imagemdocumento2 = visitante.imgDocumento2
        }

        const token = await getToken()

        sendWs('criarEditarVisitante', { visitante: visitanteObj, x_access_token: token.token, ip_equip })
    }

    addRoute('criarEditarVisitante', (msg) => {
        if (msg.data.status === true) {
            let msgObsHist = `Visitante ${msg.data.visitante.pessoaCadastrada.nome} criado/editado com sucesso!`
            setNovoVisitante(false)
            updateObsIframe(msgObsHist, msgObsHist)

            if (salvarParaAutorizacao) {
                let novaPessoa = {
                    ...visitanteInfo,
                    CD_ACESSO: msg.data.visitante.pessoaCadastrada.CD_ACESSO,
                    tag: msg.data.visitante.pessoaCadastrada.tag || '',
                    id_tag: msg.data.visitante.pessoaCadastrada.id_tag || ''
                }
                setVisitanteInfo(novaPessoa)
                setAbrirModalAutorizacao(true)
                salvarParaAutorizacao = false
                return
            }

            if (!capturarFoto) {
                showNotify('success', 'Visitante criado/editado com sucesso!')
                addVisitanteSelecionado({
                    ...visitanteInfo,
                    CD_ACESSO: msg.data.visitante.pessoaCadastrada.CD_ACESSO,
                    tag: msg.data.visitante.pessoaCadastrada.tag || '',
                    id_tag: msg.data.visitante.pessoaCadastrada.id_tag || ''
                })
                setVisitanteInfo(null)
                setAutorizarVisitante(false)
            } else {
                let novaPessoa = {
                    ...visitanteInfo,
                    CD_ACESSO: visitanteInfo.CD_ACESSO ? visitanteInfo.CD_ACESSO : msg.data.visitante.pessoaCadastrada.CD_ACESSO,
                    tag: msg.data.visitante.pessoaCadastrada.tag,
                    id_tag: msg.data.visitante.pessoaCadastrada.id_tag
                }
                setVisitanteInfo(novaPessoa)
                infoVisitanteSendCapFoto = novaPessoa
                sendCapFoto(msg.data.ip_equip)
            }
        } else if (msg.data.visitante && !msg.data.visitante.status) {
            showNotify('warning', msg.data.visitante.dados)
            salvarParaAutorizacao = false
            capturarFoto = false
        } else {
            showNotify('warning', msg.data.message)
            salvarParaAutorizacao = false
            capturarFoto = false
        }
    })

    let infoVisitanteSendCapFoto = {}

    const sendCapFoto = (ip_equip) => {
        if (Object.keys(infoVisitanteSendCapFoto).length === 0) {
            infoVisitanteSendCapFoto = visitanteInfo
        }
        setAguardandoCapFoto(true)
        setOpenModalCapFoto(true)
        sendWsCortex('capfoto', {
            status: "iniciar",
            usuario: user.id,
            panico: "",
            cd_acesso: infoVisitanteSendCapFoto.CD_ACESSO ? infoVisitanteSendCapFoto.CD_ACESSO : infoVisitanteSendCapFoto.cd_acesso,
            nome: infoVisitanteSendCapFoto.NOME ? infoVisitanteSendCapFoto.NOME : infoVisitanteSendCapFoto.nome,
            usuario_sistema: user.id,
            tag: infoVisitanteSendCapFoto.tag,
            id_tag: infoVisitanteSendCapFoto.id_tag,
            ip: ip_equip
        }, activeCond.id_central)

        addRoute('face', (msg) => {
            const { status, cd_acesso } = msg.data

            // Se a mensagem recebida não for referente ao usuário que estou editando (pode acontecer quando duas estações estão usando captura de face ao mesmo tempo)
            if (!cd_acesso || !infoVisitanteSendCapFoto || !infoVisitanteSendCapFoto.CD_ACESSO || cd_acesso != infoVisitanteSendCapFoto.CD_ACESSO) { return }

            if (status == "iniciada") { return }
            if (status == "falha") {
                if (msg.data.msg != "") {
                    showNotify('error', msg.data.msg)
                }
                setAguardandoCapFoto(false)
                capturarFoto = false
                setTimeout(() => {
                    setOpenModalCapFoto(false)
                }, 3000)
            } else if (status == "cadastrada") {
                showNotify('success', 'Sucesso ao capturar foto')
                setOpenModalCapFoto(false)
                setAguardandoCapFoto(false)
                capturarFoto = false
                if (infoVisitanteSendCapFoto.CD_ACESSO == msg.data.cd_acesso) {
                    setVisitanteInfo({ ...infoVisitanteSendCapFoto, mudarFoto: visitanteInfo.mudarFoto ? visitanteInfo.mudarFoto + 1 : 1 })
                }
            }
            infoVisitanteSendCapFoto = {}
        })
    }

    const handleCloseModalCapFoto = () => {
        sendWsCortex('capfotocanc', {
            cd_acesso: visitanteInfo.CD_ACESSO,
            usuario_sistema: user.id
        })
        setOpenModalCapFoto(false)
        setAguardandoCapFoto(false)
        capturarFoto = false
    }

    const editarVisitante = async (visitante, ip_equip = false) => {
        console.log(visitante)
        if (visitante.capFoto) {
            capturarFoto = true
            delete visitante.capFoto
            visitante.gerarTag = true
            showNotify('info', 'Aguarde enquanto a foto é capturada!')
        }
        const visitanteObj = {
            acao: 'postPessoa',
            tipo_pessoa: visitante.ID_FUNCAO || 'Visitante',
            codigo_externo: visitante.codigo_externo,
            tipo_sistema: "PLUS",
            tipoSistema: "PLUS",
            cpf: visitante.cpf,
            nome: visitante.nome,
            nascimento: formatDate(visitante.NASCIMENTO),
            tel1: visitante.telefone,
            id_central: activeCond.id_central,
            placa_veiculo: visitante.placa,
            cep: visitante.CEP,
            endereco: visitante.ENDERECO,
            numero: visitante.NUMERO,
            obs: visitante.obs,
            responsavel_modificacao: user.nome,
            face: visitante.face,
            cd_acesso: visitante.CD_ACESSO,
            gerarTag: visitante.gerarTag,
            gerarTagFacial: visitante.gerarTag ? 'true' : 'false',
            forcar_sinc_face: false, // face só vai ser sincronizada para o cortex em um segundo momento, quando operadora clicar em 'liberar acesso'
            validade_doc1: formatDate(visitante.validade_doc1),
            validade_doc2: formatDate(visitante.validade_doc2),
            validade_doc3: formatDate(visitante.validade_doc3)
        }

        if (visitante.imgDocumento) {
            visitanteObj.imagemdocumento = visitante.imgDocumento
        }
        if (visitante.imgDocumento2) {
            visitanteObj.imagemdocumento2 = visitante.imgDocumento2
        }

        const token = await getToken()

        sendWs('criarEditarVisitante', { visitante: visitanteObj, x_access_token: token.token, ip_equip })
    }

    const liberarAcessoTemp = async (tempoLiberacao, obs = "") => {
        if (visitantesSelecionados && !visitantesSelecionados.length > 0) {
            showNotify('warning', 'Selecione ao menos um visitante!')
        } else {
            const token = await getToken()

            const cdAcessoVisitantesSelecionados = visitantesSelecionados.map(v => v.CD_ACESSO)

            sendWs('liberarAcessoTemp', {
                acao: 'liberarAcessoTemp',
                pessoa: {
                    id_central: activeCond.id_central,
                    arrayCdAcesso: cdAcessoVisitantesSelecionados,
                    tempo: tempoLiberacao,
                    usuario_sistema: user.id,
                    obs
                },
                x_access_token: token.token
            })
        }
    }

    const respostaLiberarAcessoTemp = (msg) => {
        if (msg.data.status === true) {
            showNotify('success', msg.data.acesso)
            const nomesVisitantesSelecionados = visitantesSelecionados.map(v => v.nome)
            let msgObsHist = `Visitante(s) ${nomesVisitantesSelecionados.join(', ')} liberado(s) temporariamente!`
            updateObsIframe(msgObsHist, msgObsHist)
        } else {
            showNotify('error', msg.data.acesso)
        }
    }

    addRoute('liberarAcessoTemp', respostaLiberarAcessoTemp)

    const liberarAcessoVisitantes = (idEntrada, nomeEntrada = '') => {
        let dados = {
            cd_visitante: !liberarMorador ? visitantesSelecionados.map(v => v.CD_ACESSO) : [],
            obs: "",
            cd_responsavel: moradoresSelecionados.map(m => m.CD_ACESSO),
            log: 'Entrada autorizada',
            autorizado: true,
            id_central_resp: activeCond.id_central,
            saida: false,
            eMorador: false,
            id_entrada: idEntrada,
            acao: 'entrada',
            nome_user_sist: user.nome,
            id_usuario: user.id
        }
        addRoute('autorizarEntradas', (msg) => {
            const nomesVisitantesSelecionados = !liberarMorador ? visitantesSelecionados.map(v => v.nome) : moradoresSelecionados.map(m => m.nome)
            let msgObsHist = `Entrada ${nomeEntrada} aberta para visitante(s) ${nomesVisitantesSelecionados.join(', ')}!`
            updateObsIframe(msgObsHist, msgObsHist)
            showNotify('success', msg.data.message)
        })
        sendWs('autorizarEntradas', { filtros: dados })
    }

    /**
     * Insere o registro na one_historico_acessos
     */

    let opcoesLiberacao = {}

    const liberarAcessoFuturo = (tempoLiberacao, liberarFacial, notificarApp, grupoAcessoSelecionado = false, opcoesLiberacaoEscolhida = {}) => {
        if (grupoAcessoSelecionado) {
            const tagsAlterar = visitantesSelecionados
                .filter(({ tag }) => tag && !['', '0', 'null', 'undefined'].includes(tag))
                .map(({ tag }) => tag)

            if (tagsAlterar.length > 0) {
                sendWs('alterarGrupoAcesso', {
                    id_central: activeCond.id_central,
                    tags: tagsAlterar,
                    id_grupo: grupoAcessoSelecionado
                })
            }
        }
        let dados = {
            id_central: activeCond.id_central,
            cd_visitante: visitantesSelecionados.map(v => v.CD_ACESSO),
            cd_responsavel: moradoresSelecionados.map(m => m.CD_ACESSO),
            liberarTemporario: tempoLiberacao > 0 ? 1 : 0,
            liberarFacial: liberarFacial ? 1 : 0,
            notificarApp: notificarApp ? 1 : 0,
            nome_user_sist: user.nome
        }
        if (liberarFacial) {
            setJaLiberouAcesso(true)
        }
        opcoesLiberacao = opcoesLiberacaoEscolhida
        addRoute('liberarAcessoFuturo', respostaLiberarAcessoFuturo)
        sendWs('liberarAcessoFuturo', { filtros: dados })
    }

    const respostaLiberarAcessoFuturo = (msg) => {
        if (msg.data.status === true) {
            showNotify('success', msg.data.message)
            const nomesVisitantesSelecionados = visitantesSelecionados.map(v => v.nome)
            let textoLiberacao = ''
            if (opcoesLiberacao.grupoAcessoSelecionado) {
                textoLiberacao += `Alterado para o grupo de acesso ${opcoesLiberacao.grupoAcessoSelecionado}!\n`
            }
            if (opcoesLiberacao?.tempoLiberacao && opcoesLiberacao.tempoLiberacao !== '' && opcoesLiberacao.tempoLiberacao !== 'Tempo de Liberação') {
                textoLiberacao += `${opcoesLiberacao.tempoLiberacao}!\n`
            }
            if (opcoesLiberacao.notificarApp) {
                textoLiberacao += `Notificação de morador selecionado!\n`
            }
            if (opcoesLiberacao.liberarFacial) {
                textoLiberacao += `Face liberada!\n`
                setTimeout(() => {
                    sincronizarFaciais()
                }, 500)
            }
            textoLiberacao += `Visitante(s) ${nomesVisitantesSelecionados.join(', ')} liberados!`

            updateObsIframe(textoLiberacao, textoLiberacao)
            if (jaLiberouAcesso && activeCond.fecha_evento_visitante_automatico) {
                finalizarECriarEventoVisitante()
            }
        } else {
            showNotify('error', msg.data.message)
            setJaLiberouAcesso(false)
        }
    }

    /**
     * Sincroniza para o cortex as faces de todos os visitantes selecionados na tela de visitantes.
     * Atenção: Ao sincronizar a face, se a pessoa estiver na frente do facial já irá libera-la
     */
    const sincronizarFaciais = () => {
        let cd_acesso = []
        visitantesSelecionados.forEach(visi => {
            cd_acesso.push(visi.CD_ACESSO)
        })

        if (cd_acesso.length > 0) {
            sendWs('sinc_face', { id_central: activeCond.id_central, cd_acesso })
        }
    }

    const liberarTagsFaciais = async () => {
        let cd_acesso = []
        visitantesSelecionados.forEach(visi => {
            cd_acesso.push(visi.CD_ACESSO)
        })

        if (cd_acesso.length > 0) {
            const token = await getToken()
            sendWs('liberarTagsFaciais', { id_central: activeCond.id_central, cd_acesso, x_access_token: token.token })
        }
    }

    const enviaLocalizacao = async (visitante) => {
        if (!visitante.nome) {
            showNotify('error', 'Nome do visitante não informado! É necessário informar o nome do visitante para enviar a localização!')
            return
        }

        if (!visitante.telefone) {
            showNotify('error', 'Telefone do visitante não informado! É necessário informar o telefone do visitante para enviar a localização!')
            return
        }
        sendWs('enviarLocalizacao', {
            id_central: activeCond.id_central,
            localizacaoImoveis,
            visitante: {
                nome: visitante.nome,
                telefone: visitante.telefone
            }
        })
        addRoute('enviarLocalizacao', (msg) => {
            if (msg.data.status === true) {
                showNotify('success', 'Localização enviada com sucesso!')
            } else {
                showNotify('error', msg.data.message)
            }
        })
    }

    const value = {
        visitantes,
        visitanteInfo,
        moradoresSelecionados,
        visitantesSelecionados,
        imoveis,
        moradores,
        imovelSelecionado,
        activeCond,
        novoVisitante,
        buscaVisitantes,
        addMoradorSelecionado,
        removeMoradorSelecionado,
        mudarImovelSelecionado,
        buscarPorTexto,
        buscarMoradorPorFiltro,
        buscarMsgApp,
        enviarMsgApp,
        buscarInfoVisitante,
        ativarNovoVisitante,
        addVisitanteSelecionado,
        removeVisitanteSelecionado,
        criarVisitante,
        liberarAcessoTemp,
        addRoute,
        sendWs,
        liberarAcessoVisitantes,
        pesquisaNomeCpfImovel,
        liberarAcessoFuturo,
        editarVisitante,
        sendCapFoto,
        tabIndex,
        setTabIndex,
        listaSaida,
        setListaSaida,
        metricas,
        setMetricas,
        nomeMoradorBusca,
        mudarExibicao,
        modoExibicao,
        buscarVisitados,
        mudaImovelSelecionado,
        sincronizarFaciais,
        liberarTagsFaciais,
        setLiberarMoradorButton,
        liberarMorador,
        setLiberarMorador,
        selecionarAutorizacao,
        autorizarVisitante,
        autorizarVisitanteNotificarMorador,
        localizacaoImoveis,
        enviaLocalizacao,
        autorizados,
        convites,
        abrirModalAutorizacao,
        setAbrirModalAutorizacao,
        solicitarSalvarVisitante,
        setSolicitarSalvarVisitante
    }
    const btnModalCapFoto = () => {
        return (
            <Box component='div' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button onClick={handleCloseModalCapFoto} color="error" variant="contained" type="button">Cancelar</Button>
            </Box>
        )
    }
    return (
        <VisitantesContext.Provider value={value}>
            <>
                {openModalCapFoto && <OneModal
                    open={openModalCapFoto}
                    setOpen={setOpenModalCapFoto}
                    titleText="Captura de Foto Solicitada!"
                    FooterButtons={btnModalCapFoto}
                    onClose={() => { handleCloseModalCapFoto() }}
                >
                    <Box component='div' sx={{ fontWeight: 400, display: 'flex', flexDirection: "column" }}>
                        <Box component='span'>
                            {aguardandoCapFoto
                                ? <Box component='span' sx={{ fontWeight: 700, marginLeft: '5px' }}>Aguardando o usuário capturar a Foto no
                             equipamento!</Box>
                                : <Box component='span' sx={{ fontWeight: 700, marginLeft: '5px' }}>Erro ao capturar foto! Tente novamente!</Box>
                            }
                        </Box>
                    </Box>
                </OneModal>

                }
                {children}
            </>
        </VisitantesContext.Provider>
    )
}
